<template>
  <div class="set-select">
    <div class="input-warp">
      <div class="label-title">{{ label }}：</div>
      <el-select clearable @change="inputValueChange" :value="value" placeholder="请选择">
        <el-option v-for="item in rangeList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <div class="suffix-words">{{ suffix }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SetSelect',
  components: {},
  props: {
    label: {
      default: '召开前',
      type: String,
    },
    suffix: {
      default: '人',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: null,
    },
    range: {
      default: 600,
      type: Number,
    },
    partitiontype: {
      default: 1,
      type: null,
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  computed: {
    rangeList() {
      const rangeList = [];
      const sNumber = this.range;
      if (this.partitiontype === 10) {
        for (let i = 0; i <= sNumber; i++) {
          if ((i > 0 && i % this.partitiontype === 0) || i === 1) {
            rangeList.push(i);
          }
        }
      } else {
        for (let i = 0; i <= sNumber; i++) {
          if (i > 0 && i % this.partitiontype === 0) {
            rangeList.push(i);
          }
        }
      }
      return rangeList;
    },
  },
  watch: {},
  created() {},
  methods: {
    /**
     *
     */
    inputValueChange(e) {
      this.$emit('input', e);
    },
  },
};
</script>
<style lang="scss" scoped>
.input-warp {
  display: flex;
  align-items: center;
  .label-title {
    width: 80px;
    white-space: nowrap;
  }
}
.suffix-words {
  padding-left: 10px;
}
</style>
